import { render, staticRenderFns } from "./clientSms.vue?vue&type=template&id=0c76bb73&scoped=true&"
import script from "./clientSms.vue?vue&type=script&lang=js&"
export * from "./clientSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76bb73",
  null
  
)

export default component.exports